import { render, staticRenderFns } from "./person-resources.vue?vue&type=template&id=77c6ef9b&"
import script from "./person-resources.vue?vue&type=script&lang=js&"
export * from "./person-resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports